const industries = [
    "Agriculture",
    "Automotive",
    "Aerospace",
    "Biotechnology",
    "Construction",
    "Consumer Goods",
    "Education",
    "Energy",
    "Entertainment",
    "Fashion",
    "Finance",
    "Food & Beverage",
    "Healthcare",
    "Hospitality",
    "Information Technology (IT)",
    "Manufacturing",
    "Marketing & Advertising",
    "Media & Journalism",
    "Mining",
    "Pharmaceuticals",
    "Real Estate",
    "Retail",
    "Telecommunications",
    "Transportation",
    "Travel & Tourism"
];

export default industries;